import { CommonModule, DatePipe, NgForOf } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges, inject } from '@angular/core';
import { BtwCardModule } from '@between/ng-cdk/card';
import { BtwChartModule } from '@between/ng-cdk/chart';
import { Guid } from 'guid-typescript';
import { ModelDto, ModelPerformanceDto, ModelResultDto } from 'src/app/api-services/model-api/model-api.interfaces';
import { ModelApiService } from 'src/app/api-services/model-api/model-api.service';

@Component({
  selector: 'app-model-details',
  standalone: true,
  imports: [NgForOf, BtwChartModule, DatePipe, BtwCardModule, CommonModule],
  providers: [DatePipe],
  templateUrl: './model-details.component.html',
  styleUrl: './model-details.component.scss'
})
export class ModelDetailsComponent implements OnInit {
  private readonly modelApiService: ModelApiService = inject(ModelApiService);
  private readonly datePipe: DatePipe = inject(DatePipe);

  @Input({ required: true })
  modelId!: number;

  @Input({ required: true })
  analysisId!: Guid;

  model: ModelDto;

  modelPerformanceDataSource: ModelPerformanceDto[];
  modelPerformanceSeries: string[] = [];
  modelResultDataSource: ModelResultDto[];

  ngOnInit(): void {
    this.fetchModelData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modelId'] && !changes['modelId'].isFirstChange()) {
      this.fetchModelData();
    }
  }

  private fetchModelData(): void {
    if (this.modelId) {
      this.modelApiService.getById(this.modelId).subscribe(res => this.model = res);
      this.modelApiService.getModelPerformanceByModelId(this.modelId).subscribe(res => this.modelPerformanceDataSource = res);
      this.modelApiService.getModelResultsByModelAndAnalysisId(this.modelId, this.analysisId)
        .subscribe(res => {
          this.modelResultDataSource = res;
        });
    }
  }



  // private setModelPerformanceDataSource(data: ModelPerformanceDto[]): void {
  //   this.series = data[0].specificIndicatorValues.map((i) => i.name);

  //   this.dataSource = data.map(item => Object.assign(
  //     { date: item.date }, 
  //     item.specificIndicatorValues.reduce((obj, item) => Object.assign(obj, { [item.name]: item.value }), {})));
  // }
}
